import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';

@Injectable({
  providedIn: 'root'
})
export class ClusteringForecastService {
  environment = EnvironmentService.environment;

  summaryStatsChangeSubject = new Subject();
  adjustMembershipSubject = new Subject();

  constructor(private httpClient: HttpClient) { }

  // SETTINGS TAB
  fetchAlreadyUploadedFiles(userId: any, page = 1) {
    return this.httpClient.get(`${this.environment.ClusterAPI}/fetch-user-files/?user_id=${userId}&page=${page}`);
  }

  fetchFileDataById(fileName: string, userId: string, limit = 10, page = 1, matrixFaultData = false) {
    return this.httpClient.get(`${this.environment.ClusterAPI}/fetch-user-data/?user_id=${userId}&file_name=${fileName}&limit=${limit}&page=${page}&matrix_fault_data=${matrixFaultData}`);
  }

  getSASToken() {
    return this.httpClient.get(`${this.environment.ClusterAPI}/fetch-sas-token/`)
      .pipe(map((response: any) => {
        return response.payload;
      }));
  }

  uploadFileForProcessing(obj: FormData) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/user-data-upload/`, obj);
  }

  updateFileData(obj: FormData) {
    return this.httpClient.put(`${this.environment.ClusterAPI}/fetch-user-data/`, obj);
  }

  clearData(fileId: number) {
    return this.httpClient.delete(`${this.environment.ClusterAPI}/file-processing/?fileId=${fileId}`);
  }

  runClustering(obj: FormData) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/run-data-clustering/`, obj);
  }

  deleteAllFiles(obj: any = {}) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/delete-all-user-data-files/`, obj);
  }

  deleteFile(obj: any = {}) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/delete-clustering-file/`, obj);
  }

  // OUTPUT TAB
  fetchSummaryStatisticForTable(obj: any = {}) {
    return this.httpClient.get(`${this.environment.ClusterAPI}/summary-statistics-data/?data=${JSON.stringify(obj)}`);
  }

  // file_name: this.fileName,
  // user_id: this.userObj.userId,
  // cluster_id: clusterId,
  // run_tab_index: this.runIndex == 'RUN_0' ? "Cluster_Id_adj" : this.runIndex,
  // search_field: this.objectToCluster,
  // search_value: search,
  // version_no: this.versionNo

  fetchClusterColumnData(obj: any) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/fetch-vertical-clusters/`, obj);
  }

  fetchAllClusters(obj: any = {}) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/membership-table-data-list/`, obj);
  }

  adjustMembership(obj: FormData) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/adjustment-membership/`, obj);
  }

  saveRun(obj: any = {}) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/save-data-run/`, obj);
  }

  // RUN TAB
  fetchScatterPlotData(obj: FormData) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/scatter-plot/`, obj);
  }

  downloadClusterColumnsData(obj: FormData) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/download-clusterdata-file/`, obj);
  }

  // SPIDER PLOTS
  fetchSpiderChartData(obj: {}) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/spider-chart-updated/`, obj);
  }

  // Update Run Tab Name
  updateRunTabMetadata(tabObj: {}) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/update-run-tab/`, tabObj);
  }

  // Delete Run Tab Name
  deleteRun(tabObj: {}) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/delete-a-cluster-run/`, tabObj);
  }

  // File progress status
  checkFileStatus(userId: string) {
    return this.httpClient.get(`${this.environment.ClusterAPI}/data-module-clustering-progress/?user_id=${userId}`);
  }

  // Fetch file details
  fetchFileDetails(userId: string, fileName: string) {
    return this.httpClient.get(`${this.environment.ClusterAPI}/get-single-file/?user_id=${userId}&file_name=${fileName}`);
  }

  // GET FAULTY COLUMNS
  getFaultyColumns(userId: string, fileName: string, versionNo: string) {
    return this.httpClient.get(`${this.environment.ClusterAPI}/get-faulty-columns/?user_id=${userId}&file_name=${fileName}&version_no=${versionNo}`);
  }

  resetToAlgo(obj = {}) {
    return this.httpClient.post(`${this.environment.ClusterAPI}/reset-to-algo/`, obj);
  }
}
